module.exports = __webpack_public_path__ + "images/spi_logo_small.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/spi_logo_small.png
// module id = 1367
// module chunks = 0